module.exports = __webpack_public_path__ + "static/media/icon_mg01.373d0b18.svg";